import { Background } from 'shared/constants/backgrounds';
import { theme } from 'styles/theme/theme';
import transparentBackground from 'ud-ui/components/images/transparent-background.jpg';
import UDText from 'ud-ui/components/text';
import { BackgroundCard, BackgroundPlate, ColorDot, ColorRow, LogoImage } from './styles';

interface BackgroundItemProps {
  background: Background;
  img?: string;
  isActive?: boolean;
  /** Подсвечивать рамкой при наведении — только там, где по карточке можно кликнуть. */
  hoverable?: boolean;
  onClick?: () => void;
}

/** Логотип на одном из возможных фонов. */
export function BackgroundItem({ background, img, isActive, hoverable, onClick }: BackgroundItemProps) {
  // Прозрачность рисуется шахматкой: сплошного цвета у неё нет, а показать
  // «фона нет» иначе нечем.
  const isTransparent = background.value === 'transparent';
  const color = isTransparent ? undefined : background.value;
  const imgUrl = isTransparent ? (transparentBackground as string) : undefined;

  return (
    <BackgroundCard isActive={isActive} className={hoverable ? 'hover' : undefined} onClick={onClick}>
      <BackgroundPlate color={color} imgUrl={imgUrl}>
        {img && <LogoImage alt="Логотип" src={img} />}
      </BackgroundPlate>
      <ColorRow>
        <ColorDot color={color} imgUrl={imgUrl} />
        <UDText type="tip" color={theme.colors.SurfaceRomanSilver30}>
          {background.name}
        </UDText>
      </ColorRow>
    </BackgroundCard>
  );
}
